import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { createStructuredSelector } from 'reselect'
import { getIsArtist, getUserPassword, getUser } from 'Redux/selectors/auth'
import {
  changeCuratorPassword,
  changeArtistPassword,
  changeEmail,
} from 'Redux/actions/settingsActions'
import {
  getCurrenciesList,
  getRequirements,
  getCountriesList,
  getRecipient,
} from 'Redux/selectors/transferwise'
import {
  getCurrencies,
  getTransferwiseAccountRequirements,
  specifyTransferwiseAccountRequirements,
  setRequirementsToInitialState,
  addTransferwiseRecipient,
  getCountries,
} from 'Redux/actions/transferwiseActions'
import {
  deleteArtistAccount,
  deleteCuratorAccount,
} from 'Redux/actions/usersActions'
import Component from './Settings'

const selector = createStructuredSelector({
  isArtist: getIsArtist,
  currencies: getCurrenciesList,
  requirements: getRequirements,
  countries: getCountriesList,
  recipient: getRecipient,
  isPassword: getUserPassword,
  user: getUser,
  formStates: state => getFormValues('change_password')(state),
  currencyForm: state => getFormValues('currency_form')(state),
  emailForm: state => getFormValues('change_email')(state),
  bankDetailsForm: state => getFormValues('bank_details_form')(state),
  confirmForm: state => getFormValues('confirmation_form')(state),
})

const actions = {
  changeCuratorPassword,
  changeArtistPassword,
  changeEmail,
  getCurrencies,
  getTransferwiseAccountRequirements,
  specifyTransferwiseAccountRequirements,
  setRequirementsToInitialState,
  addTransferwiseRecipient,
  deleteArtistAccount,
  deleteCuratorAccount,
  getCountries,
}

export default connect(selector, actions)(Component)
